<template>
  <div>
    <template v-if="prevPageType.isOc()">
      <section>
        <div :class="[{ actionTitle: !isSpShiryo, isPc: !isSp, titleOfDocumentRequest: isSpShiryo }]">
          {{ prevPageType.isShiryo() ? 'パンフレット・願書請求' : 'オープンキャンパス予約' }}
        </div>
        <div class="appealText">
          {{ prevPageType.isShiryo() ? '＼ 今すぐ資料請求に進む ／' : '＼ 今すぐ予約に進む ／' }}
        </div>
        <ButtonLink
          :button-url="nextPageUrl"
          :button-text="actionCvButtonText"
          button-color="colorCta"
          button-size="sizeXLarge"
          max-width-none
          :class="['button', { isPc: !isSp }]"
          @button-clicked="onClickNoSignUpLink"
        />
      </section>
      <section>
        <div class="appealText appealRegistration">
          スタディサプリ会員なら次回以降カンタン{{ prevPageType.isShiryo() ? '請求' : '予約' }}
        </div>
        <ButtonLink
          button-url="/smp2/quipMember/register/infoInput/"
          :button-text="registerButtonText"
          button-color="colorPrimary"
          button-size="sizeLarge"
          :class="['registerButton button js-registerButton', { isPc: !isSp }]"
          max-width-none
          @button-clicked="clickRegisterButton($event)"
        />
      </section>
    </template>
    <section
      v-else-if="prevPageType.isOrganic() || prevPageType.isShiryo()"
      :class="['registrationArea', { isPc: !isSp }]"
    >
      <LoginPageTitle title-text="アカウントをお持ちでない方" class="titleRegistration" />
      <img v-if="isSp" src="/rnet/images/member_appeal.png" alt="" class="membershipAppealImage" />
      <ButtonLink
        :button-url="registerLink"
        button-text="新規会員登録"
        button-color="colorCta"
        button-size="sizeLarge"
        class="registerButton js-registerButton"
        max-width-none
        @button-clicked="clickRegisterButton($event)"
      />
    </section>
  </div>
</template>

<script>
import ButtonLink from '../../../common/common/Button/ButtonLink.vue';
import LoginPageTitle from './Text/LoginPageTitle.vue';
import { sendLog } from '../../../../helper/_sendLog';

export default {
  components: {
    ButtonLink,
    LoginPageTitle,
  },
  props: {
    prevPageType: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nextPageUrl: '',
      actionCvButtonText: '',
      registerButtonText: '',
    };
  },
  computed: {
    isSp() {
      return this.$isSp;
    },
    isSpShiryo() {
      return this.prevPageType.isShiryo() && this.isSp;
    },
    registerLink() {
      const urlPrefix = this.isSp ? 'smp2' : 'net2';
      return `/${urlPrefix}/quipMember/register/infoInput/`;
    },
  },
  created() {
    this.setActionInfo();
  },
  methods: {
    /**
     * アクション導線(資料請求 or OC予約)の場合、導線に対応する文字列や遷移先URLの設定を行う
     */
    setActionInfo() {
      if (this.prevPageType.isOrganic()) return;

      const paramsForActionLink = `${frontend.nextPageUrlParams}&loginRoute=1`;
      this.nextPageUrl += this.$isSp ? '/smp2' : '/net2';

      if (this.prevPageType.isShiryo()) {
        this.nextPageUrl += `/shiryoSeikyu/entry/input?${paramsForActionLink}`;
        this.actionCvButtonText = 'すぐに資料請求する';
        this.registerButtonText = '会員登録をして資料請求する';
      } else if (this.prevPageType.isOc()) {
        this.nextPageUrl += `/openCampus/reserveEntry/profile?${paramsForActionLink}`;
        this.actionCvButtonText = 'すぐに予約する';
        this.registerButtonText = '会員登録をして予約する';
      }
    },
    clickRegisterButton(event) {
      sendLog(s, event.target, `${trace_p}_signup`);
    },
    onClickNoSignUpLink(event) {
      sendLog(s, event.target, `${trace_p}_nonsignup`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.titleOfDocumentRequest {
  background-color: #043f94;
  color: #fff;
  font-size: 16px;
  text-align: center;
  line-height: 26px;
  width: 100%;
}

.actionTitle {
  font-size: $text-size-sp-h4;
  font-weight: $text-weight-bold;
  line-height: $text-line-height-little;
  margin-top: 32px;
  text-align: center;

  &.isPc {
    font-size: $text-size-pc-h3;
    margin-top: 18px;
  }
}

.appealText {
  font-size: $text-size-paragraph2;
  font-weight: $text-weight-bold;
  line-height: $text-line-height-default;
  text-align: center;
  margin: 32px 0 12px;
}

.appealRegistration {
  border-top: $border-sapuri-white-light;
  padding-top: 32px;
}

.registerButton {
  margin: 0 auto;
}

.button {
  margin: 0 20px;
  width: auto;

  &.isPc {
    width: calc(100% - 40px - 40px);
  }
}

.registrationArea {
  border-bottom: $border-sapuri-white-light;
  margin: 16px 20px 24px;
  padding-bottom: 24px;

  &.isPc {
    margin: 0 40px 32px;
    padding-bottom: 32px;
  }
}

.titleRegistration {
  margin-bottom: 16px;
}

.membershipAppealImage {
  height: auto;
  width: 100%;
  vertical-align: bottom;
  margin-bottom: 16px;
  aspect-ratio: 3 / 2;
}
</style>
